// import store from 'store'

// const { auth } = store.getState()

const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'https://mktapp-mob-api-care-uat.toyota.co.th/',
  ALIVE_X_URL: process.env.REACT_APP_ALIVE_X_URL ? process.env.REACT_APP_ALIVE_X_URL : 'https://toyotapoint.buzzebees-uat.com',
  CLIENT_URL: 'https://mktapp-mob-care-uat.toyota.co.th/',
  API_BASE_CLIENT_URL: process.env.REACT_APP_API_CLIENT_BASE_URL ? process.env.REACT_APP_API_CLIENT_BASE_URL : 'https://mktapp-mob-api-care-uat.toyota.co.th/client/',
  // HEADERS: { headers: {'x-access-token': auth.accessToken,} }
}


export default config;
